import React from 'react';
import {Icon, Anchor, Text} from '@albert-io/atomic';

interface Props {
  supportingTitleText?: string;
}

const MegaClassesEmptyState = ({supportingTitleText = 'Data will not load'}: Props) => {
  return (
    <div className='mx-auto mt-x2 flex max-w-default flex-col items-center justify-center rounded-x1 border border-subtle px-x5 py-x7'>
      <Icon icon='info-circle' iconStyle='light' className='fa-2x' />
      <Text bold className='mt-x2'>
        This class is too large. {supportingTitleText}.
      </Text>
      <div className='flex flex-col items-center'>
        <Text className='mt-x1'>For questions about accessing this data,</Text>
        <Text className='mt-x0'>
          please contact{' '}
          <Anchor as='a' href='mailto:hello@albert.io?subject=Large classroom data question'>
            hello@albert.io
          </Anchor>
        </Text>
      </div>
    </div>
  );
};

export default MegaClassesEmptyState;
